import styled from "styled-components";

export const SearchWrapper = styled.div`
  padding-right: 25px;
  background: transparent;
`;
